// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"DashboardWrapper_dashboardWrapper__XkdWv","content":"DashboardWrapper_content__+B06H"};